var map = {
	"assets/images/relics/LTW/relic_tool-g_t_skysteel-p_t_augmented_dragonsung.png": 5587,
	"assets/images/relics/LTW/relic_tool-g_t_skysteel-p_t_skybuilders.png": 134,
	"assets/images/relics/LTW/relic_tool-g_t_skysteel-p_t_skysung.png": 5865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9206;